import { ComponentProps } from "react";
import { QBox } from "@qualio/ui-components";

// Ported from document-editor's DocumentCompareVersions.module.css.
const INSERTION = "#bbf7d0";
const DELETION = "#fecaca";

export const STRIKETHROUGH_CLASS = "accessibility-strikethrough";

export const compareDiffStyles: ComponentProps<typeof QBox>["sx"] = {
  // Document typography from document-editor's DocumentLayout.module.css.
  // Chakra's reset strips heading sizes and list padding, so set them here.
  "h1.section-heading": {
    fontSize: "1.4em",
    fontWeight: "semibold",
    paddingInline: "2mm",
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  "h1.section-heading:first-of-type": { paddingTop: 0 },
  ".ck-content": { paddingInline: "2mm" },
  p: { marginBottom: "10px" },
  "ol, ul": { paddingLeft: "2em", marginBottom: "10px" },
  "li > ol, li > ul": { marginBottom: 0 },
  // htmldiff puts a replaced word's removal and insertion back to back.
  "del + ins": { marginLeft: "0.25em" },
  "ins, del": { textDecoration: "none" },
  ins: { backgroundColor: INSERTION },
  // htmldiff wraps markers around existing markup, so nested elements need the
  // highlight forced or their own backgrounds punch holes in it.
  "ins *": { background: `${INSERTION} !important` },
  "ins img": { border: `dotted ${INSERTION} medium`, padding: "4px" },
  del: { backgroundColor: DELETION },
  "del *": { background: `${DELETION} !important` },
  "del img": { border: `solid ${DELETION} medium !important`, padding: "4px" },
  [`&.${STRIKETHROUGH_CLASS} del`]: {
    textDecoration: "line-through !important",
  },
  "ins ol, del ol": { paddingLeft: "2em !important" },
  "ins > ol[multilevel], del > ol[multilevel]": {
    paddingLeft: "3.3em !important",
  },
};
